export const SN_ADDSER = 'additionalServices'
export const ADD = SN_ADDSER + '/ADD'
export const SYNC_ACTIVE = SN_ADDSER + '/SYNC_ACTIVE'
export const SET_ACTIVE = SN_ADDSER + '/SET_ACTIVE'
export const SET_BIOMETRIC_DATA = 'SET_BIOMETRIC_DATA'; // Add this mutation type
